
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[ActivitySlug]/details/[ActivityId]",
      function () {
        return require("private-next-pages/[ActivitySlug]/details/[ActivityId]/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[ActivitySlug]/details/[ActivityId]"])
      });
    }
  